import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { fetchActiveEvent } from '../lib/api';
import { Layout } from './Layout';

/**
 * Resolves the active event and renders EventPage inline (via redirect).
 * If no active event exists, shows a simple "no event" message
 * (regular users should never see the admin event list).
 */
export function ActiveEventRedirect() {
  const [activeEventId, setActiveEventId] = useState<string | null | 'loading'>('loading');

  useEffect(() => {
    fetchActiveEvent().then((ev) => {
      setActiveEventId(ev?.id ?? null);
    });
  }, []);

  if (activeEventId === 'loading') {
    return (
      <Layout>
        <div className="flex items-center justify-center min-h-[400px]">
          <div className="text-center">
            <div className="inline-block w-8 h-8 border-4 border-primary-200 border-t-primary-400 rounded-full animate-spin" />
            <p className="mt-2 text-gray-500">Loading...</p>
          </div>
        </div>
      </Layout>
    );
  }

  if (activeEventId) {
    return <Navigate to={`/event/${activeEventId}`} replace />;
  }

  // No active event
  return (
    <Layout>
      <div className="max-w-md mx-auto px-4 py-16 text-center">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Session Board</h1>
        <p className="text-gray-500">
          No event is currently active. Please check back later or contact the organizer.
        </p>
      </div>
    </Layout>
  );
}
